@import '../../global/variables/grid';

:host {
  height: 100%;
  
}

.lgr-card {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  background-color: var(--lgr-color-neutral-high-pure);
  border: 1px solid var(--lgr-color-neutral-high-medium);
  border-radius: var(--lgr-border-radius-lg);
  overflow: hidden;
  transition: transform .3s ease;

  &:hover {
    transform: translateY(-1.5rem);
    box-shadow: 0px 4px 10px 0px rgba(68, 88, 122, 0.20);
    z-index: 1;
    transition: transform .5s ease, box-shadow .5s ease;
  }

  lgr-heading {
    color: var(--lgr-color-neutral-low-dark);
  }

  img {
    width: 100%;
    aspect-ratio: 16 / 9;
    max-height: 440px;
    object-position: 50% 50%;
    overflow: hidden;
  }

  ::slotted(img) {
    width: 100%;
    height: auto;
  }

  .lgr-card-content-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin: 32px;
    overflow: hidden;

    @media (min-width: $lgr-grid-md-lg-break-point) {
      margin: 24px 24px 32px;
    }

    .lgr-card-text-container {
      display: flex;
      flex: 1;
      flex-direction: column;
      gap: 16px;
      width: 100%;

      lgr-icon {
        font-size: var(--lgr-font-size-xxxl);
      }
    }

    .lgr-card-buttons-container {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 16px;
      margin-top: var(--lgr-spacing-xxs);
    }
  }
}